import React, { useEffect } from "react"
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import { parseContent, parseContentGroup } from "./utils"

export default function TitleBlockRender({ renderPkg }:{ renderPkg?:any }){

  const styling = useRenderStyling("w-96 h-14 mt-5 bg-neutral-200 border border-solid border-neutral-700 rounded-md flex justify-center items-center text-2xl font-semibold uppercase", "styleObj")

  const settings = renderPkg.dispute.elements.find((setting:any) => setting.refstr === "title_block").settings || {}

  return (
    <div id="mm-titleblock" {...styling}>
      { settings?.displayTitle || "Dispute Evidence" }
    </div>
  )
}